import { IRequesterInfo, KeyValuePair } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { addDealerType, addExcludeTestDealers } from '../analyticsQuery'
import { IChatFeedbackReport, IFeedbackReportParams } from '../models'

/**
 * Geri bildirim raporu (ADR-021, Faz-37): `vote` verilmezse sunucu varsayılanı `down`'dur; aktif olarak
 * sonuçlandırılmış olumsuzlar listede yer almaz (Tamamlananlar'dadır). Bayi düzeyinde.
 */
export class GetFeedbackReportApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({ url: 'admin/chatbot-analytics/feedback', requesterInfo })
  }

  public async getReport(params: IFeedbackReportParams): Promise<IChatFeedbackReport> {
    const query = new KeyValuePair<string>()
    query.add('fromUtc', params.fromUtc.toISOString())
    query.add('toUtc', params.toUtc.toISOString())
    if (params.vote) query.add('vote', params.vote)
    if (params.reasonCode) query.add('reasonCode', params.reasonCode)
    query.add('onlyWithComment', String(params.onlyWithComment))
    if (params.search) query.add('search', params.search)
    if (params.text) query.add('text', params.text)
    query.add('page', String(params.page))
    query.add('pageSize', String(params.pageSize))
    query.add('export', String(params.export))
    addExcludeTestDealers(query, params.excludeTestDealers)
    addDealerType(query, params.dealerType)
    this.queryParams = query
    return await this.getAsync<IChatFeedbackReport>()
  }
}
